const FLAG_PREFIX = '--';

const isBareFlag = (line: string) => line.startsWith(FLAG_PREFIX) && !line.includes('=') && !line.includes(' ');

/** One line per `--flag` with the value that follows it; anything else gets its own line. Line 1 is the command. */
export function formatCommandLines(command: string, args: ReadonlyArray<string>): string[] {
  const lines = [command];
  let lastIsBareFlag = false;

  for (const arg of args) {
    const last = lines.length - 1;

    if (!arg.startsWith(FLAG_PREFIX) && lastIsBareFlag) {
      lines[last] = `${lines[last]} ${arg}`;
      lastIsBareFlag = false;
    } else {
      lines.push(arg);
      lastIsBareFlag = isBareFlag(arg);
    }
  }

  return lines;
}
